import React, { useState, useEffect } from 'react';
import { Modal, Table, Button, Badge, Alert, Spinner, Row, Col, Card } from 'react-bootstrap';
import { getEmployeeLeaveRequests, formatTurkishDate } from '../../services/api';

const EmployeeLeaveListModal = ({ show, onHide, employee }) => {
    // **STATE YÖNETİMİ**
    const [leaveData, setLeaveData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // **İZİN TİPLERİ DISPLAY NAME**
    const leaveTypeDisplayNames = {
        'yıllık': 'Yıllık İzin',
        'hastalık': 'Hastalık İzni',
        'mazeret': 'Mazeret İzni',
        'babalık': 'Babalık İzni',
        'doğum': 'Doğum İzni',
        'diğer': 'Diğer'
    };



    // İKİSİNİ DE İNGİLİZCE YAP
    const getLeaveStatusColor = (status) => {
        switch (status) {
            case 'approved': return 'success';      // ✅ İngilizce
            case 'pending': return 'warning';
            case 'rejected': return 'danger';
            default: return 'secondary';
        }
    };

    const getLeaveStatusDisplayName = (status) => {
        switch (status) {
            case 'approved': return 'Onaylandı';    // ✅ İngilizce enum, Türkçe display
            case 'pending': return 'Beklemede';
            case 'rejected': return 'Reddedildi';
            default: return status;
        }
    };

    // **MODAL AÇILDIĞINDA İZİN VERİLERİNİ YÜKLE**
    useEffect(() => {
        if (show && employee?._id) {
            loadEmployeeLeaveData();
        }
    }, [show, employee]);

    // **PERSONEL İZİN VERİLERİNİ BACKEND'DEN YÜKLE**
    const loadEmployeeLeaveData = async () => {
        try {
            setLoading(true);
            setError('');

            const response = await getEmployeeLeaveRequests(employee._id);

            console.log('🔍 API Response:', response);  // 👈 DEBUG EKLE

            if (response.success) {
                setLeaveData(response.data);
                console.log('✅ Leave Data Set:', response.data);  // 👈 DEBUG EKLE
            }
        } catch (error) {
            setError('İzin verileri yüklenirken hata oluştu');
            console.error('Load employee leave data error:', error);
        } finally {
            setLoading(false);
        }
    };

    // **İZİN RAPORU OLUŞTUR**
    const handleLeaveReport = (leaveRequest) => {
        try {
            const token = localStorage.getItem('token');

            if (!token) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                return;
            }

            // İzin raporu için URL (sonra backend endpoint ekleyeceğiz)
            const reportUrl = `${process.env.REACT_APP_API_URL}/employees/${employee._id}/leave-report/${leaveRequest._id}?token=${token}`;

            window.open(reportUrl, '_blank', 'noopener,noreferrer');
        } catch (error) {
            console.error('İzin raporu açılırken hata:', error);
            alert('İzin raporu açılırken hata oluştu');
        }
    };

    // **TARİH FORMATLAMA**
    const formatDateRange = (startDate, endDate) => {
        if (!startDate || !endDate) return '-';

        const start = formatTurkishDate(startDate);
        const end = formatTurkishDate(endDate);

        if (start === end) {
            return start;
        }

        return `${start} - ${end}`;
    };

    return (
        <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>📋 İzin Listesi ve Hakları</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {/* **PERSONEL BİLGİSİ** */}
                {employee && (
                    <div className="mb-4 p-3 bg-light rounded">
                        <Row>
                            <Col md={6}>
                                <h6 className="mb-1">{employee.personalInfo?.fullName}</h6>
                                <small className="text-muted">
                                    {employee.workInfo?.position} - {employee.workInfo?.department}
                                </small>
                            </Col>
                            <Col md={6} className="text-end">
                                <small className="text-muted">TC: {employee.personalInfo?.tcNo}</small>
                            </Col>
                        </Row>
                    </div>
                )}

                {/* **LOADING DURUMU** */}
                {loading && (
                    <div className="text-center py-4">
                        <Spinner animation="border" size="sm" className="me-2" />
                        İzin verileri yükleniyor...
                    </div>
                )}

                {/* **HATA MESAJI** */}
                {error && (
                    <Alert variant="danger">
                        {error}
                    </Alert>
                )}

                {/* **İZİN HAKLARI ÖZETİ** */}
                {leaveData?.leaveRights && (
                    <Row className="mb-4">
                        <Col md={4}>
                            <Card className="text-center h-100">
                                <Card.Body>
                                    <h4 className="text-primary">{leaveData.leaveRights.annual || 0}</h4>
                                    <small className="text-muted">Yıllık İzin Hakkı</small>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="text-center h-100">
                                <Card.Body>
                                    <h4 className="text-warning">{leaveData.leaveRights.used || 0}</h4>
                                    <small className="text-muted">Kullanılan İzin</small>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="text-center h-100">
                                <Card.Body>
                                    <h4 className="text-success">{leaveData.leaveRights.remaining || 0}</h4>
                                    <small className="text-muted">Kalan İzin</small>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                )}

                {/* **İZİN LİSTESİ** */}
                {leaveData?.leaveRequests && (
                    <div>
                        <h6 className="mb-3">📅 İzin Geçmişi ({leaveData.leaveRequests.length})</h6>

                        {leaveData.leaveRequests.length > 0 ? (
                            <div className="table-responsive">
                                <Table striped hover className="mb-0">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>İzin Türü</th>
                                            <th>Tarih Aralığı</th>
                                            <th>Gün Sayısı</th>
                                            <th>Durum</th>
                                            <th>Sebep</th>
                                            <th>Talep Tarihi</th>
                                            <th>İşlemler</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {leaveData.leaveRequests.map((leave, index) => (
                                            <tr key={leave._id || index}>
                                                <td>
                                                    <Badge bg="secondary">
                                                        {leaveTypeDisplayNames[leave.leaveType] || leave.leaveType}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    {formatDateRange(leave.startDate, leave.endDate)}
                                                </td>
                                                <td>
                                                    <strong>{leave.days || 0} gün</strong>
                                                </td>
                                                <td>
                                                    <Badge bg={getLeaveStatusColor(leave.status)}>
                                                        {getLeaveStatusDisplayName(leave.status)}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    <small className="text-muted">
                                                        {leave.reason || '-'}
                                                    </small>
                                                </td>
                                                <td>
                                                    <small className="text-muted">
                                                        {formatTurkishDate(leave.requestDate)}
                                                    </small>
                                                </td>
                                                <td>
                                                    {leave.status === 'approved' && (
                                                        <Button
                                                            size="sm"
                                                            variant="outline-primary"
                                                            onClick={() => handleLeaveReport(leave)}
                                                            title="İzin Raporu"
                                                        >
                                                            📄 Rapor
                                                        </Button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            <div className="text-center py-5">
                                <p className="text-muted">Henüz izin talebi bulunmuyor</p>
                            </div>
                        )}
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Kapat
                </Button>
                {employee && (
                    <Button
                        variant="primary"
                        onClick={() => {
                            onHide();
                            // Parent component'e callback gönder
                            if (window.openLeaveModal) {
                                window.openLeaveModal(employee);
                            }
                        }}
                    >
                        ➕ Yeni İzin Ekle
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default EmployeeLeaveListModal;